import { SET_AUTH_DATA, LOG_OUT_USER, IS_LOADING, LOGIN, CHANGE_TEMPORARY_PASSWORD, CONFIRM_FORGET_PASSWORD_REQUEST, FORGET_PASSWORD_REQUEST} from './types/root/actions-types';
import {SET_AUTH_DATA_IN_STATE} from "./types/root/mutations-types"
import api from "../api/api"
import showMessage from "../utils/alert"
import router from '@/router';

export default {

    [LOGIN]: async ({ commit }, body)=>{
        let response = {}
        try {
            commit(SET_AUTH_DATA_IN_STATE, body)
            response =   await api.post("/login", body)
            const reponseBody = response.data.body
            if ("token" in reponseBody){
                commit(SET_AUTH_DATA_IN_STATE, {username: body.username, password: '', temp_password: ''})
                commit(SET_AUTH_DATA, reponseBody)
                router.push({ name: 'leaderboard' });
            }
        } catch (err) {
            commit(IS_LOADING, false)
        }
        return response
    },

    [CHANGE_TEMPORARY_PASSWORD]: async ({ commit }, body)=>{
        let response = {}
        try{
            response =   await api.post("/users/reset-password", body)
            commit(IS_LOADING, false)
        } catch (err) {
            commit(IS_LOADING, false)
        }
        return response
    },

    [FORGET_PASSWORD_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        try {
            response =   await api.post("/forgot-password/send-verification-code", body)
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                if(reponseBody.message === "Verification code sent. Please check your email.")
                    router.push({ name: 'confirm-forget-password' });
            }
        } catch (err) {
            commit(IS_LOADING, false)
        }
        return response
    },

    [CONFIRM_FORGET_PASSWORD_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        try {
            response =   await api.post("/forgot-password/confirm-forgot-password", body)
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                if(reponseBody.message === "Password set. Please login to continue."){
                    commit(SET_AUTH_DATA_IN_STATE, { username: body.username, password: body.new_password })
                    router.push({ name: 'login' });
                }
            }
        } catch (err) {
            console.log(err)
            commit(IS_LOADING, false)
        }
        return response
    },
}
